import Vue from 'vue'
import MirgPopup from '@/components/MirgPopup.vue';
import VueSocialSharing from 'vue-social-sharing'
import { BCollapse } from 'bootstrap-vue';
import StarRating from '@/components/StarRating.vue';
import Slider from '@/components/Slider.vue';
import { useDialog } from '@/composables/useDialog';
import { initVue } from '@/vue';

Vue.use(VueSocialSharing);

const dialogManager = useDialog();

dialogManager.register({
	'email-business': () => import('@/includes/forms/EmailBusiness.vue'),
})

initVue({
	el: '#tdapp',
	components: {
		'star-rating': StarRating,
		'mirg-popup': MirgPopup,
		'b-collapse': BCollapse,
		'app-slider': Slider,
	}
})
